<script setup>
import TD from "@/Components/Table/Element.vue";

import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, onUnmounted } from "vue";
import { Inertia } from "@inertiajs/inertia";

const page_name = "Urlaub";

const props = defineProps({
  vacation: Object,
  errors: Object,
  practitioner: Object,
});

// onUnmounted(
//   Inertia.on("before", (event) => {
//     if (form.isDirty) {
//       return confirm("Wollen Sie diese Seite wirklich verlassen?");
//     }
//   })
// );

const canDelete = Inertia.page.props.auth.can["delete settings"];

const form = useForm({
  practitioner_id: props.vacation.practitioner_id,
  start: props.vacation.start,
  end: props.vacation.end,
  fullday: !!props.vacation.fullday,
  annotation: props.vacation.annotation,
});

function deleteVacation() {
  Inertia.delete(`/employeeVacations/${props.vacation.id}`, {});
}

function submitForm() {
  form.put(`/employeeVacations/${props.vacation.id}`);
}
</script>

<template>
  <SettingsLayout>
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink
        class="mr-3"
        href="/einstellungen/mitarbeiterurlaub"
        type="close"
        >Zurück</HeaderLink
      >
      <HeaderButton
        v-if="canDelete"
        class="mr-3"
        @click="deleteVacation()"
        type="close"
        >Löschen</HeaderButton
      >
      <HeaderButton @click="submitForm()">Speichern</HeaderButton>
    </template>
    <Heading title="Behandlerurlaub editieren" />

    <p class="max-w-2xl text-sm text-oteoText mb-9">
      Separater Urlaub der einzelnen Mitarbeiter.
    </p>
    <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
      <div class="">
        <Label> Mitarbeiter/in</Label>

        <Select
          v-model="form.practitioner_id"
          :disabled="true"
          class="w-full max-w-sm mr-4"
        >
          <option :value="practitioner.id">
            {{ `${practitioner.firstname} ${practitioner.lastname}` }}
          </option>
        </Select>
      </div>
    </div>
    <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
      <div class="">
        <Label class="mr-4 inline-block"> Ganztägig </Label>
        <input @change="changeType()" v-model="form.fullday" type="checkbox" />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.fullday">
          {{ errors.fullday }}
        </div>
      </div>
    </div>

    <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
      <div class="">
        <Label> Beginn </Label>

        <Input
          v-model="form.start"
          class="w-full"
          :min="
            form.fullday
              ? new Date().toISOString().split('T')[0]
              : new Date().toISOString().split('T')[0] + 'T00:00:00'
          "
          :type="form.fullday ? 'date' : 'datetime-local'"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.start">
          {{ errors.start }}
        </div>
      </div>
    </div>

    <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
      <div class="">
        <Label> Ende </Label>

        <Input
          v-model="form.end"
          class="w-full"
          @focus="
            () => {
              if (!form.end) {
                form.end = form.start;
              }
            }
          "
          :type="form.fullday ? 'date' : 'datetime-local'"
        />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.end">
          {{ errors.end }}
        </div>
      </div>
    </div>

    <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
      <div class="">
        <Label>Anmerkungen</Label>
        <Input v-model="form.annotation" class="w-full" />
        <div class="mt-2 text-red-600 text-sm" v-if="errors.annotation">
          {{ errors.annotation }}
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

